import { decamelize } from 'humps';
import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';
import { EstateUpsellMeta } from '/@/modules/estateupsell/models/metas/EstateUpsellMeta';
import { EstateUpsellClearWillComponentProp } from '/@/modules/estateupsell/constants/EstateUpsellClearWillComponentProp';

export class EstateUpsell extends BaseEntityModel {
  /**
   * @var {number}
   */
  id;

  /**
   * @var {number}
   */
  estateId;

  /**
   * @var {string}
   */
  metaType;

  /**
   * @var {EstateUpsellClearWillMeta|EstateUpsellClearEstateMeta}
   */
  meta;

  constructor(model = {}) {
    super(model);

    this.id = model.id;
    this.estateId = model.estateId;
    this.metaType = model.metaType;
    this.meta = EstateUpsellMeta.factory(model);
  }

  /**
   * @var {boolean}
   */
  get hasUpsellsSelected() {
    // eslint-disable-next-line no-restricted-syntax
    for (const [key] of Object.entries(this.meta)) {
      if (this.meta[key] === true) {
        return true;
      }
    }

    return false;
  }

  /**
   * @var {boolean}
   */
  get selectedEnumItems() {
    return Object.entries(this.meta).reduce((accum, [key, value]) => {
      if (!value) {
        return accum;
      }

      const enumItem = EstateUpsellClearWillComponentProp.getByKey(decamelize(key));
      if (enumItem) {
        accum.push(enumItem);
      }

      return accum;
    }, []);
  }
}
